import transactions from './list/reducers'
import wallet from './wallet/reducers'
import transactionTypes from './transactionTypes/reducers'
import cards from './cards/reducers'
import setupIntent from './setupIntent/reducers'
import topup from './topup/reducers'

export default {
  transactions,
  wallet,
  transactionTypes,
  cards,
  setupIntent,
  topup,
}
